module.exports = __webpack_public_path__ + "995ba08a8c9d69c9430f285bde13b97e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/galeriaFotos/077.jpg
// module id = 61
// module chunks = 0